import React from 'react';
import ReactDOM from 'react-dom';

import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import './styles/tailwind.css';
import './styles/cookiebot.css';
import './fonts/atkinson/fonts.css';
import './fonts/allergo-medica/style.css';
import App from './pages/app';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
